import React, { useEffect, useState } from 'react';
import { Alert, Button, Checkbox, Input, Modal, Space, Typography, notification } from 'antd';
import AxiosUtils from 'utils/axios-utils';
import { API } from 'service/api-route';
import { apiErrorText, formatScore } from './types';

interface Props {
  open: boolean;
  voteId: number | string;
  voteTitle?: string;
  people: number;
  totalScore: number;
  onClose: () => void;
  onDone: () => void;
}

/** Reset điểm cả sự kiện — hỏi Có / Không, tuỳ chọn làm mới lượt vote của người xem. */
const ResetScoreModal = ({
  open,
  voteId,
  voteTitle,
  people,
  totalScore,
  onClose,
  onDone,
}: Props) => {
  const [resetVoterVotes, setResetVoterVotes] = useState(false);
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setResetVoterVotes(false);
      setReason('');
    }
  }, [open]);

  const submit = async () => {
    setSaving(true);
    try {
      const res: any = await AxiosUtils.post(API.voteAdminReset(voteId), {
        reason: reason.trim() || undefined,
        resetVoterVotes,
      });
      const cleared = res?.data?.clearedVotes ?? 0;
      notification.success({
        message: 'Đã reset điểm',
        description: resetVoterVotes
          ? `Điểm về 0 và làm mới ${formatScore(cleared)} lượt vote của người xem.`
          : 'Điểm của mọi người tham gia đã về 0.',
      });
      onDone();
    } catch (e) {
      notification.error({ message: 'Không thành công', description: apiErrorText(e) });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Reset điểm toàn bộ sự kiện?"
      onCancel={onClose}
      maskClosable={false}
      footer={[
        <Button key="no" onClick={onClose}>
          Không
        </Button>,
        <Button key="yes" type="primary" danger loading={saving} onClick={submit}>
          Có, reset điểm
        </Button>,
      ]}
    >
      <Space direction="vertical" size={14} style={{ width: '100%' }}>
        <Typography.Text>
          Điểm của <b>{people}</b> người tham gia
          {voteTitle ? (
            <>
              {' '}
              trong <b>{voteTitle}</b>
            </>
          ) : null}{' '}
          sẽ về <b>0</b> (hiện tổng {formatScore(totalScore)} điểm). Bảng xếp hạng trên app cập nhật
          ngay.
        </Typography.Text>
        <Checkbox checked={resetVoterVotes} onChange={(e) => setResetVoterVotes(e.target.checked)}>
          Làm mới cả lượt vote của người xem (mọi người được vote lại từ đầu)
        </Checkbox>
        <Input
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          maxLength={255}
          placeholder="Lý do (không bắt buộc) — vd. Bắt đầu vòng 2"
        />
        <Alert
          type="warning"
          showIcon
          message="Không hoàn tác được. Điểm trước khi reset vẫn được ghi trong Lịch sử điều chỉnh."
        />
      </Space>
    </Modal>
  );
};

export default ResetScoreModal;
